export const prefix = '@@lossAss/'
export const GET_LATEST_REPORT_FINISH = `${prefix}GET_LATEST_REPORT_FINISH`
export const GET_HISTORY_REPORT_FINISH = `${prefix}GET_HISTORY_REPORT_FINISH`
export const SET_CURRENT_REPORT = `${prefix}SET_CURRENT_REPORT`
export const SEARCH_REPORT_FINISH=`${prefix}SEARCH_REPORT_FINISH`
export const REPORT_PAGE_FORM=`${prefix}REPORT_PAGE_FORM`
export const SELECTED_REPORT=`${prefix}SELECTED_REPORT`
export const FORM_VIDEO_PHOTO=`${prefix}FORM_VIDEO_PHOTO`
export const SELECTED_CAR=`${prefix}SELECTED_CAR`
export const GET_ACCIDENT_CARS=`${prefix}GET_ACCIDENT_CARS`
export const SHOWPICTUREMODAL=`${prefix}SHOWPICTUREMODAL`
export const BIND_AGENT_FINISH=`${prefix}BIND_AGENT_FINISH`
export const CHANGE_ACTIVE_REPORT_TAB = `${prefix}CHANGE_ACTIVE_REPORT_TAB`
export const LOAD_CUSTOMER_UPLOAD_IMG = `${prefix}LOAD_CUSTOMER_UPLOAD_IMG`
export const UPLOAD_PICC_FINISH=`${prefix}UPLOAD_PICC_FINISH`;
export const UPLOAD_PICC_FAILED=`${prefix}UPLOAD_PICC_FAILED`
export const UPLOAD_PICC_INITIATE=`${prefix}UPLOAD_PICC_INITIATE`
export const CREATE_CAR_FAILED=`${prefix}CREATE_CAR_FAILED`
export const CREATE_CAR_INITIATE=`${prefix}CREATE_CAR_INITIATE`
export const CREATE_CAR_FINISH=`${prefix}CREATE_CAR_FINISH`
export const GET_TBC_REPORT_FINISH=`${prefix}GET_TBC_REPORT_FINISH`
export const GET_CREATE_REPORT_OR_DETAILE=`${prefix}GET_CREATE_REPORT_OR_DETAILE`
export const CREATE_REPORT_FINISH=`${prefix}CREATE_REPORT_FINISH`
export const UPLOAD_NOTIFICATION_FINISH = `${prefix}UPLOAD_NOTIFICATION_FINISH`

export const UPLOAD_IMG_QUICK_INITIATE = `${prefix}UPLOAD_IMG_QUICK_INITIATE`
export const UPLOAD_IMG_QUICK_FINISH = `${prefix}UPLOAD_IMG_QUICK_FINISH`
export const UPLOAD_IMG_QUICK_FAILED = `${prefix}UPLOAD_IMG_QUICK_FAILED`
export const ONSELECTEDINSTITUTION = `${prefix}ONSELECTEDINSTITUTION`
export const CREATE_INSTITUTION_FINISHED = `${prefix}CREATE_INSTITUTION_FINISHED`
export const SEARCH_BUSACCOUNT_LIST = `${prefix}SEARCH_BUSACCOUNT_LIST`
export const CREATE_BUSACCOUNT_FINISHED = `${prefix}CREATE_BUSACCOUNT_FINISHED`
export const UPDATE_BUSACCOUNT_FINISHED = `${prefix}UPDATE_BUSACCOUNT_FINISHED`
export const DELETE_BUSACCOUNT_FINISH = `${prefix}DELETE_BUSACCOUNT_FINISH`
export const DELETE_BUSACCOUNT_FAILD = `${prefix}DELETE_BUSACCOUNT_FAILD`
export const UPLOAD_SHOT_PIC_FINISH =  `${prefix}UPLOAD_SHOT_PIC_FINISH`
export const UPLOAD_IMG_START_FINISH = `${prefix}UPLOAD_IMG_START_FINISH`
export const EDIT_CURRENT_REQUEST_FINISH = `${prefix}EDIT_CURRENT_REQUEST_FINISH`
export const SHOW_MEASURE_FINISH = `${prefix}SHOW_MEASURE_FINISH`

export const UPDATE_AREA_REPORTS = `${prefix}UPDATE_AREA_REPORTS`
export const UPDATE_CITY_REPORTS = `${prefix}UPDATE_CITY_REPORTS`


export const RELEVANT_REPORT_FINISH = `${prefix}RELEVANT_REPORT_FINISH`

export const SHOW_EVALUATION = `${prefix}SHOW_EVALUATION`
export const GET_UTILS_CODE_FINISH = `${prefix}GET_UTILS_CODE_FINISH`

export const FETCH_LIVE_PLAY_SUCCESS = `${prefix}FETCH_LIVE_PLAY_SUCCESS`

export const RECEIVE_TXFIT_URL = `${prefix}RECEIVE_TXFIT_URL`
export const SENDED_TXFIT_URL_TO_BACKGROUD = `${prefix}SENDED_TXFIT_URL_TO_BACKGROUD`

export const CPIC_CLASSIFY_PICS_FINISH = `${prefix}CPIC_CLASSIFY_PICS_FINISH`

export const DELETE_COORPERATION_FINISH = `${prefix}DELETE_COORPERATION_FINISH`
export const FORBID_INSTITUTION_FINISH=`${prefix}FORBID_INSTITUTION_FINISH`
export const FORBID_BUSACCOUNT_FINISH=`${prefix}FORBID_BUSACCOUNT_FINISH`
export const SET_ROTATE_IMG_LOSS_CENTER_FINISH=`${prefix}SET_ROTATE_IMG_LOSS_CENTER_FINISH`


export const GET_TASK_FINISH = `${prefix}GET_TASK_FINISH`
export const CHANGE_PHOTO_SUPPLEMENT_STATE_FINISH = `${prefix}CHANGE_PHOTO_SUPPLEMENT_STATE_FINISH`
export const DEL_PICTURES_FINISH = `${prefix}DEL_PICTURES_FINISH`
export const SORT_PICTURES_FINISH = `${prefix}SORT_PICTURES_FINISH`
export const REPORT_CHECKING_FINISH = `${prefix}REPORT_CHECKING_FINISH`
export const ASSIGN_REPORT = `${prefix}ASSIGN_REPORT`
export const TRANSFER_RECORDS = `${prefix}TRANSFER_RECORDS`

export const SET_REPORT_CHECKED_STATUS = `${prefix}SET_REPORT_CHECKED_STATUS`
export const CHANGE_DATE_RANGE = `${prefix}CHANGE_DATE_RANGE`
export const CHANGE_CHANNEL_TYPE = `${prefix}CHANGE_CHANNEL_TYPE`
export const CHANGE_HAS_LEAVE_MSG_TYPE = `${prefix}CHANGE_HAS_LEAVE_MSG_TYPE`
export const CHANGE_SEARCH_TYPE_PARAMS = `${prefix}CHANGE_SEARCH_TYPE_PARAMS`
export const CLEAR_SEARCH_PARAMS = `${prefix}CLEAR_SEARCH_PARAMS`
export const CHANGE_VIDEO_SURVEY = `${prefix}CHANGE_VIDEO_SURVEY`
export const CHANGE_SEARCH_INPUT = `${prefix}CHANGE_SEARCH_INPUT`
export const CHANGE_ACTIVE_REPORT_TABLE_TABS = `${prefix}CHANGE_ACTIVE_REPORT_TABLE_TABS`
export const GET_REPORT_LIST_CLASSIFY_FAILD = `${prefix}GET_REPORT_LIST_CLASSIFY_FAILD`
export const GET_REPORT_LIST_CLASSIFY_SUCCESS = `${prefix}GET_REPORT_LIST_CLASSIFY_SUCCESS`
export const SEARCH_REPORT_LIST_CLASSIFY_SUCCESS = `${prefix}SEARCH_REPORT_LIST_CLASSIFY_SUCCESS`
export const GET_CURRENT_REPORT_FINISH = `${prefix}GET_CURRENT_REPORT_FINISH`
export const SEND_LEAVE_MESSAGE_FAILD = `${prefix}SEND_LEAVE_MESSAGE_FAILD`
export const AGENT_ACCEPT_REPORT_FINISH = `${prefix}AGENT_ACCEPT_REPORT_FINISH`
export const AGENT_ACCEPT_REPORT_FAILED = `${prefix}AGENT_ACCEPT_REPORT_FAILED`
export const RESET_REPORT_STATE_SUCCESS = `${prefix}RESET_REPORT_STATE_SUCCESS`
export const RESET_REPORT_STATE_FAILED = `${prefix}RESET_REPORT_STATE_FAILED`
export const SEND_DEFLOSS_PREVIEW_SUCCESS = `${prefix}SEND_DEFLOSS_PREVIEW_SUCCESS`
export const SEND_DEFLOSS_PREVIEW_FAILED = `${prefix}SEND_DEFLOSS_PREVIEW_FAILED`
export const SEND_RETURNED_MSG_FAILD = `${prefix}SEND_RETURNED_MSG_FAILD`
export const SET_RETURNED_MODAL = `${prefix}SET_RETURNED_MODAL`
export const SET_DEFLOSS_PREVIEW_MODAL = `${prefix}SET_DEFLOSS_PREVIEW_MODAL`
export const UPLOAD_PIC_SUCCESS = `${prefix}UPLOAD_PIC_SUCCESS`
export const UPLOAD_PIC_FAILED = `${prefix}UPLOAD_PIC_FAILED`
export const SEARCH_BANKS_SUCCESS = `${prefix}SEARCH_BANKS_SUCCESS`
export const SEARCH_BANKS_FAILED = `${prefix}SEARCH_BANKS_FAILED`
export const CREATE_TPA_REPORT_BY_AGENT_SUCCESS = `${prefix}CREATE_TPA_REPORT_BY_AGENT_SUCCESS`
export const CREATE_TPA_REPORT_BY_AGENT_FAILED = `${prefix}CREATE_TPA_REPORT_BY_AGENT_FAILED`
export const UPDATE_REPORT_FORM_DATA = `${prefix}UPDATE_REPORT_FORM_DATA`
export const ADD_OR_REDUCE_REPORT_ITEMS = `${prefix}ADD_OR_REDUCE_REPORT_ITEMS`
